export default {
  loading: false,
  successAccion: false,
  error: '',
  templates: {},
  template: {},
  schema: {
    display: 'form'
  },
  schemaChanges: {}
};
